import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Clock, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Bandeau d'essai gratuit 60 min : invisible sauf pour un compte en essai.
export default function TrialBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const sub = user?.subscription || {};
  const [remaining, setRemaining] = useState(null);

  const isTrial = sub.status === "trialing" && user?.role !== "superadmin";
  const trialEnd = sub.trial_end;

  useEffect(() => {
    if (!isTrial || !trialEnd) { setRemaining(null); return; }
    const tick = () => {
      const ms = new Date(trialEnd).getTime() - Date.now();
      setRemaining(ms);
      if (ms <= 0) navigate("/abonnement");
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [isTrial, trialEnd, navigate]);

  if (!isTrial) return null;

  if (!trialEnd) {
    return (
      <div data-testid="trial-banner-idle" className="flex items-center justify-center gap-2 bg-[#0F172A] px-4 py-2 text-sm text-white">
        <Sparkles className="h-4 w-4 text-[#C6A87C]" />
        {t("radar.banner.idle")}
      </div>
    );
  }

  const secs = Math.max(0, Math.floor((remaining || 0) / 1000));
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  const urgent = secs <= 300;

  return (
    <div data-testid="trial-banner" className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-sm text-white ${urgent ? "bg-red-700" : "bg-[#0F172A]"}`}>
      <span className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#C6A87C]" /> {t("radar.banner.remaining")}
        <b className="tabular-nums" data-testid="trial-countdown">{mm}:{ss}</b>
      </span>
      <button onClick={() => navigate("/abonnement")} data-testid="trial-banner-cta" className="rounded-full bg-[#C6A87C] px-3 py-1 text-xs font-semibold text-[#0F172A] hover:brightness-105">
        {t("radar.banner.choosePlan")}
      </button>
    </div>
  );
}
